const actionCodeMenus = [
  {
    icon: "edit",
    key: "Action_Code_Master",
    name: "Action Code Master",
    url: "home/app/ActionCodeMaster",
    description: "",
    productionReady: true,
  },
  {
    icon: "summarize",
    key: "Action_Code_List",
    name: "Action Code List",
    url: "home/app/ActionCodeList",
    description: "",
    productionReady: true,
  },
  {
    icon: "details",
    key: "PBX_Service",
    name: "PBX Service",
    url: "home/app/PBXService",
    description: "",
    productionReady: true,
  },
  {
    icon: "request_quote",
    key: "Voice_Guidance",
    name: "Voice Guidance",
    url: "home/app/VoiceGuidance",
    description: "",
    productionReady: true,
  },
  {
    icon: "summarize_icon",
    key: "Dial_Code_List",
    name: "Dial Code List",
    url: "home/app/DialCodeList",
    description: "",
    productionReady: true,
  },
  {
    icon: "article",
    key: "FXO_Drop_Code",
    name: "FXO Drop Code",
    url: "home/app/FXODropCode",
    description: "",
    productionReady: true,
  },
  {
    icon: "call_icon",
    key: "tenant",
    name: "Tenant Master",
    description: "",
    url: "home/app/tenant",
    disabled: false,
    productionReady: true,
  },
  {
    icon: "crisis_alert",
    key: "Trunk_Access_Code",
    name: "Trunk Access Code",
    url: "home/app/TrunkAccessCode",
    description: "",
    productionReady: true,
  },
];

export { actionCodeMenus };
